'use client'

import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import Image from 'next/image'
import { useRef } from 'react'
import { akamaiSmartCropLoaderFactory } from 'utils/image/loaders/akamaiSmartCropLoaderFactory'
import { isBot } from 'utils/isBot/IsBot'
import type { PointOfInterestImage } from '../../../../Home.type'
import styles from './FamilyDirectAccessImage.module.css'

const IMAGE_ASPECT_RATIO = 1

interface FamilyDirectAccessImageProps {
	readonly image: PointOfInterestImage
	readonly isPrioritySlot?: boolean
}

export const FamilyDirectAccessImage = ({
	image,
	isPrioritySlot,
}: FamilyDirectAccessImageProps) => {
	const divRef = useRef<HTMLDivElement>(null)
	const entry = useIntersectionObserver(divRef, {
		threshold: 0.01,
		freezeOnceVisible: true,
	})
	const imageHeightCalc = (width: number) => width / IMAGE_ASPECT_RATIO
	const imageLoader = akamaiSmartCropLoaderFactory({
		heightCalcFunction: imageHeightCalc,
	})

	return (
		<div ref={divRef} className={styles.familyImage}>
			{entry?.isIntersecting || isBot() ? (
				<Image
					alt={image.description ?? ''}
					src={image.url}
					loader={imageLoader}
					sizes='(max-width: 1023px) 144px, 192px'
					draggable={false}
					priority={isPrioritySlot}
					fill
				/>
			) : null}
		</div>
	)
}
